import { intersection, head } from 'lodash';

import ACTIVITY_MARKER_COLORS from '../data/activity_styles';
import { isActivityCompleted } from '../lib/answers';
import { ANCHORED_ACTIVITIES, EVIDENCE_TAG } from '../data/activity_types';

/* eslint-disable global-require */
const anchoredActivitiesStyles = {
  evidenceTagging: {
    icon: require('../content/activity_anchor/evidence.svg'),
  },
  inlineActivity: {
    icon: require('../content/activity_anchor/inline-activity-big.svg'),
  },
};

function findEffectiveType(activityType) {
  let anchoredType = head(intersection(ANCHORED_ACTIVITIES, activityType.split(' ')));
  anchoredType = anchoredType && anchoredType.startsWith('inline') ? 'inlineActivity' : anchoredType;

  return {
    isAnchored: !!anchoredType,
    effectiveType: anchoredType || activityType,
  };
}

export const findAnsweredActivities = (allActivities, answeredActivities) => {
  if (!answeredActivities.length) {
    return [];
  }

  return Object.values(allActivities).filter(activity => isActivityCompleted(answeredActivities, activity));
};

export function getActivityProfile({ activity }) {
  const { effectiveType, isAnchored } = findEffectiveType(activity.className);

  const activityAnchorIcon = anchoredActivitiesStyles[effectiveType];

  const backgroundColor = ACTIVITY_MARKER_COLORS[`${effectiveType}`];
  const backgroundColorActive = ACTIVITY_MARKER_COLORS[`${effectiveType}Active`];

  return {
    activityType: effectiveType,
    anchoredActivity: isAnchored,
    activityStyles: {
      backgroundColor,
      backgroundColorActive,
      icon: activityAnchorIcon ? activityAnchorIcon.icon : null,
    },
  };
}

export const isAnsweredCorrectlyOnFirstTry = ({ correct, attempts, attemptsBase = 1 } = {}) =>
  !!correct && attempts === attemptsBase;

export const isInlineActivityAnswered = (answer) => {
  const { activityType } = answer || {};

  if (!activityType) {
    return false;
  }

  const attemptsBase = activityType === EVIDENCE_TAG ? 1 : 0;
  return isAnsweredCorrectlyOnFirstTry({ ...answer, attemptsBase });
};

export const createActivityId = (activityId, activityType) => `${activityType}_${activityId}`;
